import React, { useState, useEffect, useCallback } from 'react';
import Parser from 'html-react-parser';
import translate from "../../../classes/lang";

const RxCall = global.rootRequire('components/shares/rxCall').default;
const RxGroupCall = global.rootRequire('components/shares/rxGroupCall').default;
const RxPopup = global.rootRequire('components/shares/rxPopup').default;
const RxMessMenu = global.rootRequire('components/shares/rxMessMenu').default;
const RxCreateGroupPopup = global.rootRequire('components/shares/create_group_popup/rxCreateGroupPopup').default;

const { changeColorSVG } = global.rootRequire('classes/ulti');

const GroupsComponent = global.rootRequire('themes/main/chat/groups').default;
const MessagesComponent = global.rootRequire('themes/main/chat/messages').default;
const HeaderChatComponent = global.rootRequire('themes/main/chat/header').default;
const RxModalEdit = global.rootRequire('components/shares/rxModalEdit').default;
const FooterChatComponent = global.rootRequire('themes/main/chat/footer').default;

const Calendar = global.rootRequire('components/shares/calendar').default;

global.isclient && require('./index.css');

let adminCSS = '<style>.main-container{ width: 100% !important; padding: 0px !important; } .homenav, .footer{ display: none !important; }</style>';

// Separate functional component for the Left Menu
const LeftMenu = ({ setComp }) => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  // Effect to handle screen resize and auto-close menu on wider screens
  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth > 768) {
        setIsMenuOpen(true); // Keep the menu open on larger screens
      } else {
        setIsMenuOpen(false); // Collapse the menu on mobile screens
      }
    };

    handleResize(); // Initialize menu state based on current width
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  // Toggle menu visibility on mobile
  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  return (
    <div>
      <button className="menu-toggle" onClick={toggleMenu}>
        <img src={changeColorSVG('./images/default/icons/menu.svg')} alt='Menu' className='menu-icon' />
      </button>

      <div className={`zleft_menu ${isMenuOpen ? 'open' : ''}`}>
        <RxMessMenu />
        <div className='zmenu_contact' onClick={() => setComp('contact')}>
          <img src={changeColorSVG('./images/default/icons/contact.svg')} alt='' className='zmenu_icon icon' />
        </div>
        <div className='zmenu_config' onClick={() => setComp('config')}>
          <img src={changeColorSVG('./images/default/icons/config.svg')} alt='' className='zmenu_icon icon' />
        </div>
      </div>
    </div>
  );
};

// The main Chat body
const ChatBody = ({ vm }) => {
  const [state, setState] = useState({
    flagCalendar: false,
    displayAddContact: false,
    flagEdit: false,
    contactInfo: {},
    flagBlockFooter: false,
    tabmore: false,
    groups: []
  });

  const checkClickOutside = useCallback((e) => {
    // Implement click outside logic here
  }, []);

  const showFooterFunc = useCallback(() => {
    setState(prevState => ({ ...prevState, flagBlockFooter: false }));
  }, []);

  const blockFooterFunc = useCallback(() => {
    setState(prevState => ({ ...prevState, flagBlockFooter: true }));
  }, []);

  const closeCalendar = useCallback(() => {
    setState(prevState => ({ ...prevState, flagCalendar: false }));
  }, []);

  return (
    <div onClick={checkClickOutside}>
      <div>
        <div id='chat-value'></div>
        <RxCall />
        <RxGroupCall />
        <RxPopup />
        <RxCreateGroupPopup />

        {state.flagCalendar && <Calendar closeCalendar={closeCalendar} />}
        
        <style>
          {`
            @media (max-width: 768px) {
              .zchat_left {
                display: none;
                position: fixed;
                top: 0;
                left: 0;
                height: 100%;
                width: 300px;
                background-color: white;
                z-index: 1000;
                transition: transform 0.3s ease-in-out;
              }
              .zchat_left.show {
                display: block;
                transform: translateX(0);
              }
              .zchat_right {
                padding-left: 0;
              }
              .menu-toggle {
                display: block;
                position: fixed;
                top: 10px;
                left: 10px;
                z-index: 1001;
              }
            }
          `}
        </style>

        <button className="menu-toggle" onClick={() => {
          const leftMenu = document.querySelector('.zchat_left');
          leftMenu.classList.toggle('show');
        }}>
          
          <img src={changeColorSVG('./images/default/icons/menu.svg')} alt='Menu' className='menu-icon' />
        </button>
        
        <div className='zchat_left'>
          <LeftMenu setComp={vm.props.setComp} />
          <GroupsComponent callBackShowFooter={showFooterFunc} />
        </div>

        <div className='zchat_right'>
          <div className='zright_contain'>
            <HeaderChatComponent />
            <MessagesComponent
              tabmore={state.tabmore}
              groups={state.groups}
              callBackRedirectChat={vm.callBackRedirectParent}
              callBackBlockFooter={blockFooterFunc}
            />

            {!state.flagBlockFooter && <FooterChatComponent />}
          </div>

          {state.displayAddContact && (
            <RxModalEdit
              onClickModalEdit={() => setState(prevState => ({ ...prevState, displayAddContact: false, flagEdit: false, contactInfo: {} }))}
              onSubmitContact={vm.onSubmitContact}
              flagEdit={state.flagEdit}
              contactInfo={state.contactInfo}
            />
          )}
        </div>
      </div>
    </div>
  );
};

// Main render function
export const renderBody = (vm) => <ChatBody vm={vm} />;

// Rendering the entire component with Parser and conditionally rendering based on activeComponent
export const renderComponent = (vm) => (
  <div>
    {Parser(adminCSS)}
    {vm.props.activeComponent !== 'login' && <ChatBody vm={vm} />}
  </div>
);